// LUMINA · pages/vajra/admin/ShopSection.jsx
// Phase 59C: 法宝管理 — 新建/编辑/状态切换/下架

import React, { useState, useEffect, useCallback } from 'react';
import { API, GD, TXT, TXT2 } from '../constants';
import ImageUpload from '../../../components/ImageUpload';

const CATEGORIES = [
  { key: 'vase',       label: '宝瓶' },
  { key: 'instrument', label: '法器' },
  { key: 'text',       label: '法本' },
  { key: 'thangka',   label: '唐卡' },
  { key: 'mala',      label: '念珠' },
  { key: 'other',     label: '其他' },
];
const STATUSES = [
  { key: 'available', label: '可请' },
  { key: 'reserved',  label: '待确认' },
  { key: 'sold',      label: '已请' },
];

const EMPTY_FORM = {
  name_zh: '', name_en: '', description_zh: '', description_en: '',
  category: 'other', image_url: '', suggested_amount_cad: '',
  status: 'available', linked_credential_key: '', linked_event_id: '',
  is_active: true, sort_order: 0, topic_hub_slug: '',
};

const lbl  = { fontSize: 11, color: TXT2, marginBottom: 3, display: 'block' };
const inp  = { width: '100%', padding: '5px 8px', borderRadius: 5, border: '1px solid rgba(0,0,0,0.12)', fontSize: 12, boxSizing: 'border-box', background: '#fff', marginBottom: 8 };

export default function ShopSection({ token, headers, hubList = [] }) {
  const [products, setProducts]   = useState([]);
  const [form, setForm]           = useState(EMPTY_FORM);
  const [editId, setEditId]       = useState(null);
  const [msg, setMsg]             = useState('');
  const [showForm, setShowForm]   = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await fetch(`${API}/vajra/shop/products`, { headers });
      if (res.ok) {
        const d = await res.json();
        setProducts(d.products || []);
      }
    } catch {}
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load]);

  const openNew = () => {
    setForm(EMPTY_FORM);
    setEditId(null);
    setShowForm(true);
    setMsg('');
  };

  const openEdit = (p) => {
    setForm({
      name_zh:               p.name_zh || '',
      name_en:               p.name_en || '',
      description_zh:        p.description_zh || '',
      description_en:        p.description_en || '',
      category:              p.category || 'other',
      image_url:             p.image_url || '',
      suggested_amount_cad:  p.suggested_amount_cad || '',
      status:                p.status || 'available',
      linked_credential_key: p.linked_credential_key || '',
      linked_event_id:       p.linked_event_id || '',
      is_active:             p.is_active !== false,
      sort_order:            p.sort_order || 0,
      topic_hub_slug:        p.topic_hub_slug || '',
    });
    setEditId(p.id);
    setShowForm(true);
    setMsg('');
  };

  const save = async () => {
    const body = {
      ...form,
      suggested_amount_cad: form.suggested_amount_cad ? parseInt(form.suggested_amount_cad) : null,
      linked_event_id:      form.linked_event_id ? parseInt(form.linked_event_id) : null,
      sort_order:           parseInt(form.sort_order) || 0,
    };
    const url    = editId ? `${API}/vajra/staff/shop/products/${editId}` : `${API}/vajra/staff/shop/products`;
    const method = editId ? 'PATCH' : 'POST';
    try {
      const r = await fetch(url, { method, headers: { ...headers, 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (r.ok) {
        setMsg('✓ 保存成功');
        setShowForm(false);
        load();
      } else {
        const e = await r.json();
        setMsg('✗ ' + (e.detail || '保存失败'));
      }
    } catch { setMsg('✗ 网络错误'); }
  };

  const del = async (id) => {
    if (!window.confirm('确认下架此法宝？')) return;
    try {
      const r = await fetch(`${API}/vajra/staff/shop/products/${id}`, { method: 'DELETE', headers });
      if (r.ok) { setMsg('✓ 已下架'); load(); }
    } catch {}
  };

  const quickStatus = async (p, status) => {
    try {
      await fetch(`${API}/vajra/staff/shop/products/${p.id}`, {
        method: 'PATCH', headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify({ status }),
      });
      load();
    } catch {}
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div style={{ fontSize: 14, color: GD, fontWeight: 600 }}>法宝管理 ({products.length})</div>
        <button onClick={openNew} style={{ padding: '5px 14px', borderRadius: 6, cursor: 'pointer', background: GD, color: '#fff', border: 'none', fontSize: 12 }}>
          + 新增法宝
        </button>
      </div>

      {msg && <div style={{ fontSize: 12, padding: '4px 8px', borderRadius: 5, marginBottom: 10, color: msg.startsWith('✓') ? '#059669' : '#dc2626' }}>{msg}</div>}

      {/* 新建/编辑表单 */}
      {showForm && (
        <div style={{ background: 'rgba(212,175,55,0.04)', border: '1px solid rgba(212,175,55,0.15)', borderRadius: 10, padding: 16, marginBottom: 20 }}>
          <div style={{ fontSize: 13, color: GD, marginBottom: 12 }}>{editId ? '编辑法宝' : '新增法宝'}</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 12px' }}>
            <div>
              <label style={lbl}>名称（中文）*</label>
              <input value={form.name_zh} onChange={e => setForm(f => ({ ...f, name_zh: e.target.value }))} placeholder="财神宝瓶" style={inp} />
            </div>
            <div>
              <label style={lbl}>名称（英文）</label>
              <input value={form.name_en} onChange={e => setForm(f => ({ ...f, name_en: e.target.value }))} placeholder="Dzambala Treasure Vase" style={inp} />
            </div>
            <div style={{ gridColumn: '1/-1' }}>
              <label style={lbl}>描述（中文）</label>
              <textarea value={form.description_zh} onChange={e => setForm(f => ({ ...f, description_zh: e.target.value }))} rows={3} style={{ ...inp, resize: 'vertical' }} />
            </div>
            <div>
              <label style={lbl}>分类</label>
              <select value={form.category} onChange={e => setForm(f => ({ ...f, category: e.target.value }))} style={inp}>
                {CATEGORIES.map(c => <option key={c.key} value={c.key}>{c.label}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>状态</label>
              <select value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))} style={inp}>
                {STATUSES.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>建议供养 (CAD)</label>
              <input type="number" value={form.suggested_amount_cad} onChange={e => setForm(f => ({ ...f, suggested_amount_cad: e.target.value }))} placeholder="500" style={inp} />
            </div>
            <div>
              <label style={lbl}>排序值（小的在前）</label>
              <input type="number" value={form.sort_order} onChange={e => setForm(f => ({ ...f, sort_order: e.target.value }))} style={inp} />
            </div>
            <div style={{ gridColumn: '1/-1' }}>
              <label style={lbl}>图片（主图）</label>
              <ImageUpload
                currentUrl={form.image_url}
                onUpload={(url) => setForm(f => ({ ...f, image_url: url }))}
                label="上传法宝图片"
              />
              {form.image_url && (
                <input value={form.image_url} onChange={e => setForm(f => ({ ...f, image_url: e.target.value }))}
                  placeholder="或直接输入URL" style={{...inp, marginTop: 6, fontSize: 11, color: '#888'}} />
              )}
            </div>
            <div>
              <label style={lbl}>关联灌顶 Key（结缘匹配）</label>
              <input value={form.linked_credential_key} onChange={e => setForm(f => ({ ...f, linked_credential_key: e.target.value }))} placeholder="21dzambala" style={inp} />
            </div>
            <div>
              <label style={lbl}>关联法会 ID（结缘匹配）</label>
              <input type="number" value={form.linked_event_id} onChange={e => setForm(f => ({ ...f, linked_event_id: e.target.value }))} placeholder="法会 ID" style={inp} />
            </div>
            <div>
              <label style={lbl}>关联专题</label>
              <select value={form.topic_hub_slug||""} onChange={e=>setForm(f=>({...f,topic_hub_slug:e.target.value||null}))} style={inp}>
                <option value="">— 无关联专题 —</option>
                {hubList.map(h=><option key={h.slug} value={h.slug}>{h.title_zh} ({h.slug})</option>)}
              </select>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="checkbox" checked={form.is_active} onChange={e => setForm(f => ({ ...f, is_active: e.target.checked }))} id="isActive" />
              <label htmlFor="isActive" style={{ fontSize: 12, color: TXT2 }}>上架展示</label>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <button onClick={save} style={{ padding: '6px 20px', borderRadius: 6, cursor: 'pointer', background: GD, color: '#fff', border: 'none', fontSize: 12 }}>保存</button>
            <button onClick={() => setShowForm(false)} style={{ padding: '6px 14px', borderRadius: 6, cursor: 'pointer', background: 'none', border: '1px solid #ddd', color: '#888', fontSize: 12 }}>取消</button>
          </div>
        </div>
      )}

      {/* 法宝列表 */}
      {products.length === 0 ? (
        <div style={{ fontSize: 12, color: '#bbb', padding: '20px 0' }}>暂无法宝，点击「新增法宝」开始</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
              {['ID', '名称', '分类', '建议金额', '状态', '操作'].map(h => (
                <th key={h} style={{ textAlign: 'left', padding: '6px 8px', color: TXT2, fontWeight: 600 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {products.map(p => (
              <tr key={p.id} style={{ borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
                <td style={{ padding: '8px 8px', color: TXT2 }}>#{p.id}</td>
                <td style={{ padding: '8px 8px', color: TXT }}>{p.name_zh}</td>
                <td style={{ padding: '8px 8px', color: TXT2 }}>{p.category}</td>
                <td style={{ padding: '8px 8px', color: GD }}>{p.suggested_amount_cad ? `$${p.suggested_amount_cad}` : '—'}</td>
                <td style={{ padding: '8px 8px' }}>
                  <select value={p.status} onChange={e => quickStatus(p, e.target.value)} style={{ fontSize: 11, padding: '2px 4px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: 4, background: '#fff', color: TXT }}>
                    {STATUSES.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
                  </select>
                </td>
                <td style={{ padding: '8px 8px' }}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => openEdit(p)} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 4, cursor: 'pointer', background: 'none', border: '1px solid rgba(139,105,20,0.3)', color: GD }}>编辑</button>
                    <button onClick={() => del(p.id)} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 4, cursor: 'pointer', background: 'none', border: '1px solid rgba(220,38,38,0.3)', color: '#dc2626' }}>删除</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
